import { useReducer } from 'react';
import config from '../utils/constants/config';
import _ from 'lodash';

const initialState = state => {
    return {
        page: 1,
        limit: state && state.limit ? state.limit : config.defaultListSize,
        totalPages: null,
        count: null,
        totalCount: null,
        isFetching: true,
        totalItems: null,
        filters: {},
    };
};

const GO_AT_PREVIOUS = 'GO_AT_PREVIOUS';
const GOT_AT_NEXT = 'GOT_AT_NEXT';
const GO_AT_END = 'GO_AT_END';
const GO_AT_START = 'GO_AT_START';
const GO_AT_PAGE = 'GO_AT_PAGE';
const HANDLE_PAGE_SIZE_CHANGE = 'HANDLE_PAGE_SIZE_CHANGE';
const SET_STATE = 'SET_STATE';
const SET_STATE_FILTERS = 'SET_STATE_FILTERS';
const CLEAR_FILTER = 'CLEAR_FILTER';

const reducer = (state, action) => {
    switch (action.type) {
        case GO_AT_PREVIOUS:
            if (state.page === 1) {
                return state;
            }

            return {
                ...state,
                page: state.page - 1,
                isFetching: true,
            };
        case GOT_AT_NEXT:
            if (state.page === state.totalPages) {
                return {
                    ...state,
                    isFetching: true,
                };
            }
            return {
                ...state,
                page: state.page + 1,
                isFetching: true,
            };
        case GO_AT_END:
            return {
                ...state,
                page: state.totalPages,
                isFetching: true,
            };
        case GO_AT_START:
            return {
                page: 1,
                limit: state.limit,
                isFetching: true,
            };
        case GO_AT_PAGE:
            return {
                ...state,
                page: action.payload,
                isFetching: true,
            };
        case HANDLE_PAGE_SIZE_CHANGE:
            return {
                ...state,
                limit: parseInt(action.payload),
                page: 1,
                isFetching: true,
            };
        case SET_STATE:
            return {
                ...action.payload,
                filters: state.filters ? state.filters : null,
                isFetching: false,
                filterState: false,
            };
        case SET_STATE_FILTERS: {
            return {
                ...state,
                page:
                    !_.isEqual(state.filters, action.payload) &&
                    state.page !== 1
                        ? 1
                        : state.page,
                filters: action.payload,
                isFetching: true,
            };
        }
        case CLEAR_FILTER: {
            return {
                ...state,
                filters: null,
            };
        }

        default:
            return state;
    }
};

const usePagination = props => {
    const [state, dispatch] = useReducer(reducer, initialState(props));
    const goAtPrevious = () => dispatch({ type: GO_AT_PREVIOUS });
    const goAtNext = () => dispatch({ type: GOT_AT_NEXT });
    const goAtEnd = () => dispatch({ type: GO_AT_END });
    const goAtStart = () => dispatch({ type: GO_AT_START });
    const goAtPage = page => dispatch({ type: GO_AT_PAGE, payload: page });
    const handlePageSizeChange = limit =>
        dispatch({ type: HANDLE_PAGE_SIZE_CHANGE, payload: limit });
    const setState = state => dispatch({ type: SET_STATE, payload: state });
    const setFiltersState = filters =>
        dispatch({ type: SET_STATE_FILTERS, payload: filters });
    const clearFilterState = () => dispatch({ type: CLEAR_FILTER });

    return {
        pagerState: state,
        goAtPrevious,
        goAtNext,
        goAtEnd,
        goAtStart,
        goAtPage,
        handlePageSizeChange,
        setState,
        setFiltersState,
        clearFilterState,
    };
};

export default usePagination;
